"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentTags = void 0;

var _index = require("../../index");

var _react = _interopRequireDefault(require("react"));

require("./MomentTags.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Moment Tags
var MomentTags = function MomentTags(_ref) {
  var tags = _ref.tags;
  return /*#__PURE__*/_react.default.createElement(_index.Row, {
    className: "MomentTags"
  }, tags && tags.map(function (tag, index) {
    return /*#__PURE__*/_react.default.createElement(_index.TagChip, {
      key: "tc-personal-".concat(tag.name),
      category: "personal",
      tag: tag,
      marginBottom: 2,
      marginRight: 2
    });
  }));
};

exports.MomentTags = MomentTags;